import { useEffect, useRef, useState } from 'react';
import styled from "styled-components";
import { colors } from 'src/common/colors';
import { FormControl, Button, Flex, Box, HStack, useDisclosure, RadioGroup, Stack} from '@chakra-ui/react'
// import RadioGroup from '../common/RadioGroup';
import SRadio from '../common/SRadio';
import { useNavigate, useParams } from 'react-router-dom';
import SInput from '../common/SInput';
import ActionButton from '../common/ActionButton';
import useGetProgramDetail from 'src/hooks/ManageProgram/useGetProgramDetail';
import { useForm, Controller } from 'react-hook-form'
import { 레벨번역, 영역번역, radio프로그램레벨, radio프로그램영역 } from '../../common/util'
import SModal from '../common/SModal';
import useDeleteProgram from 'src/hooks/ManageProgram/useDeleteProgram';
import useCreateProgram from 'src/hooks/ManageProgram/useCreateProgram';
import useUpdateProgram from 'src/hooks/ManageProgram/useUpdateProgram';
import SToast from '../common/SToast';

export default function ProgramCreate() {
    const { programId } = useParams();
    const stringProgramId = programId ?? '';
    const numProgramId = parseInt(stringProgramId, 10); 
    const { getProgramDetail, programDetail } = useGetProgramDetail();
    const { createProgram } = useCreateProgram();
    const { updateProgram } = useUpdateProgram();
    const { deleteProgram } = useDeleteProgram();
    const { register, handleSubmit, setValue, control, formState } = useForm();
    const [selectedImage, setSelectedImage] = useState<File | null | undefined>(null);
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const { errorToast, successToast, customErrorToast } = SToast();
    const navigate = useNavigate();
    const { errors } = formState;

    const { 
        isOpen: isOpenDeleteModal, 
        onOpen: onOpenDeleteModal, 
        onClose: onCloseDeleteModal
    } = useDisclosure();

    const { 
        isOpen: isOpenUpdateModal, 
        onOpen: onOpenUpdateModal, 
        onClose: onCloseUpdateModal
    } = useDisclosure();

    const onFinish = async (formData:any) => {
        const form = new FormData();
    
        form.append('programName', formData.programName);
        form.append('programLevel', formData.programLevel);
        form.append('detailLevel', formData.detailLevel);
        form.append('programArea', formData.programArea);
        form.append('programDetail', formData.programDetail);
        if (selectedImage) {
            form.append('guideImage', selectedImage);
        }
    
        if (programId) {
            form.append('programId', stringProgramId);
            const updateCall = await updateProgram(form);
            if (updateCall === 200) {
                successToast('성공적으로 수정됐습니다.');
                navigate(-1);
            } else {
                errorToast();
            }
        } else {
            const createCall = await createProgram(form);
            if (createCall === 200) {
                successToast('성공적으로 생성됐습니다.');
                navigate(-1);
            } else {
                errorToast();
            }
        }
    };

    const onDeleteProgram = async () => {
        const deleteCall = await deleteProgram(numProgramId);
          if (deleteCall === 200) {
            successToast('성공적으로 삭제됐습니다.');
            navigate(-1);
          } else {
            errorToast();
          }
    };

    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        setSelectedImage(file || null);
        setValue('guideImageName', file?.name)
    };

    useEffect(()=>{
        if(programId) {
            getProgramDetail()
        }
    },[])

    useEffect(()=>{
        setValue('programName', programDetail?.data.programName)
        setValue('programLevel', programDetail?.data.programLevel)
        setValue('detailLevel', programDetail?.data.detailLevel)
        setValue('programArea', programDetail?.data.programArea)
        setValue('programDetail', programDetail?.data.programDetail)
        setValue('guideImageName', programDetail?.data.guideImageName)
    },[programDetail])

    useEffect(()=>{
        if(Object.keys(errors).length > 0) {
            customErrorToast('모든 항목을 채워 넣어 주세요')
        }
    },[errors])
    
    return(
        <Container>
            <Title>{programId? '프로그램 정보' : '프로그램 등록'}</Title>
            <SubTitle>기본 정보</SubTitle>

            <form onSubmit={(e) => {e.preventDefault()}}>
                <FormControl>
                    <SFlex>
                        <SBox>프로그램 이름</SBox>
                        <SDiv>
                            <SInput name='programName' register={register} require={true}/>
                        </SDiv>
                    </SFlex>
                </FormControl>
                <FormControl>
                    <SFlex>
                        <SBox>프로그램 레벨</SBox>
                        <SDiv>
                            <Controller
                                name="programLevel"
                                control={control}
                                rules={{
                                    required: true,
                                }}
                                render={({ field: { onChange, value } }) => (
                                    <RadioGroup onChange={onChange} value={value}>
                                        <Stack direction="row">
                                            {radio프로그램레벨.map((item) => (
                                                <SRadio key={item} value={item}
                                                isChecked={value === item} 
                                                onChange={onChange}
                                                >
                                                    {레벨번역(item)}
                                                </SRadio>
                                            ))}
                                        </Stack>
                                    </RadioGroup>
                                )}
                            />
                        </SDiv>
                    </SFlex>
                </FormControl>
                <FormControl>
                    <SFlex>
                        <SBox>프로그램 세부 레벨</SBox>
                        <SDiv>
                            <SInput type='number' name='detailLevel' register={register} require={true}/>
                        </SDiv>
                    </SFlex>
                </FormControl>
                <FormControl>
                    <SFlex>
                        <SBox>프로그램 영역</SBox>
                        <SDiv>
                            <Controller
                                name="programArea"
                                control={control}
                                rules={{
                                    required: true,
                                }}
                                render={({ field: { onChange, value } }) => (
                                    <RadioGroup onChange={onChange} value={value}>
                                        <Stack direction="row">
                                            {radio프로그램영역.map((item) => (
                                                <SRadio key={item} value={item}
                                                isChecked={value === item} 
                                                onChange={onChange}
                                                >
                                                    {영역번역(item)}
                                                </SRadio>
                                            ))}
                                        </Stack>
                                    </RadioGroup>
                                )}
                            />
                        </SDiv>
                    </SFlex>
                </FormControl>
                <FormControl>
                    <SFlex>
                        <SBox>프로그램 설명</SBox>
                        <SDiv>
                            <SInput name='programDetail' register={register} require={true}/>
                        </SDiv>
                    </SFlex>
                </FormControl>
                <FormControl>
                    <SFlex>
                        <SBox>가이드북 등록</SBox>
                        <SDiv>
                            <Flex>
                                <SInput name='guideImageName' register={register} readOnly={true} />
                                <LoadButton onClick={() => fileInputRef.current?.click()}>
                                    불러오기
                                </LoadButton>
                                <input
                                    ref={fileInputRef}
                                    id='guideImage'
                                    type='file'
                                    style={{ display: 'none' }}
                                    onChange={handleImageChange}
                                />
                            </Flex>
                        </SDiv>
                    </SFlex>
                </FormControl>
            </form>
            <HStack marginTop='17px' paddingBottom='65px' justifyContent='right'>
                {programId ?
                <>
                    <Button color='brand.red' bg='none' padding={0} 
                    _hover={{bg: "white", color:'hover.red'}} marginRight='auto'
                    onClick={onOpenDeleteModal}>
                        프로그램 삭제
                    </Button>
                    <ActionButton 
                    backgroundColor={colors.button.red} 
                    _hover={{bg: "hover.red", color:'white'}} 
                    text='수정하기' 
                    onClick={onOpenUpdateModal}
                    />
                </>
                : <>
                    <ActionButton 
                    backgroundColor={colors.button.red} 
                    _hover={{bg: "hover.red", color:'white'}} 
                    type="submit"
                    text='등록하기' 
                    onClick={handleSubmit(onFinish)}
                    />
                </>}
            </HStack>

            <SModal 
                title='삭제하기'
                desc='정말로 삭제하시겠습니까?'
                onClick={onDeleteProgram} 
                isOpen={isOpenDeleteModal} 
                onOpen={onOpenDeleteModal} 
                onClose={onCloseDeleteModal} 
            />

            <SModal 
                title='수정하기'
                desc='정말로 수정하시겠습니까?'
                onClick={handleSubmit(onFinish)} 
                isOpen={isOpenUpdateModal} 
                onOpen={onOpenUpdateModal} 
                onClose={onCloseUpdateModal} 
            />
        </Container>
    )
}

const Container = styled.div`
min-width: 850px;
width: calc(100vw - 506px);
`

const Title = styled.div`
color: ${colors.black};
font-family: 'KFAGothicBold';
font-size: 22px;
margin-bottom: 55px;
`

const SubTitle = styled.div`
color: ${colors.black};
font-size: 18px;
width: 100%;
padding-bottom: 10px;
border-bottom: 1px solid ${colors.lineGrey};
`

const SFlex = styled(Flex)`
padding: 23px 0;
border-bottom: 1px solid ${colors.lineGrey};
`

const SBox = styled(Box)` 
width: 137px;
height: 41px;
line-height: 41px;
font-size: 16px;
`
const SDiv = styled.div`
width: calc(100% - 137px);
font-size: 14px;
`

const LoadButton = styled.button`
background-color: #3652E0;
color: white;
width: 120px;
height: 41px;

`;